import React from "react"
import Spinner from "components/Spinner"
import "./ChartHolder.css"

export default function ChartHolder({title, subtitle, children, isLoading, noData}) {



    return <div className="chart">
        <h2>
            {title}
            {subtitle && <span className="subtitle">{subtitle}</span>}
        </h2>
        <div className="chart-content">
            {isLoading && <Spinner/>}
            {!isLoading && noData && <div className="no-data">No data</div>}
            {!isLoading && !noData && <div className="padder">{children}</div>}
        </div>
    </div>

}